

/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";

export class TheBorderGameAssets {

    static BITMAP_FONT_FS_NUMBERS: string = "fsNumbers";
    static BITMAP_FONT_WIN_NUMBERS: string = "winNumbers";
    static BITMAP_FONT_SPLIT_SYMBOL_NUMBERS: string = "symXMultiplyer";
    static BITMAP_FONT_MULTIPLIER_NUMBERS: string = "multiplierNumbers";
    static BITMAP_FONT_SFS_MULTIPLIER_NUMBERS: string = "Super_Bonus_Multiplier_Font";
    static BITMAP_FONT_FS_OUTRO_NUMBER: string = "FSOutroNumber";
    static BITMAP_FONT_FS_OUTRO_NUMBER_SHINE: string = "FSOutroNumberShine";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FS_BACKGROUND: string = "freespinBackground";
    public static SUPER_FS_BACKGROUND: string = "superFreespinBackground";
    public static INTRO_BACKGROUND: string = "Bonus_won_Intro/bonusSign";
    public static INTRO_TOP_DIRT: string = "Bonus_won_Intro/topDirt";
    public static INTRO_SHIELD: string = "Bonus_won_Intro/shield";
    public static INTRO_XBOMB: string = "Bonus_won_Intro/xBomb";
    public static INTRO_XWAY: string = "Bonus_won_Intro/xWays";
    public static INTRO_CAYOTE: string = "Bonus_won_Intro/cayoteSign";
    public static INTRO_MULE: string = "Bonus_won_Intro/muleSign";
    public static WIN_MULTIPLIER_BACKGROUND: string = "x-Multiplier_BG";
    public static BOOST_BUTTON_OFF:string = "Boost/boostButtonOff";

    //Spine
    public static X_NUDGE_SPINE: string = "spine/WR.json";
    public static SYMBOL_TO_WILD_SPINE: string = "spine/SymbolToWild.json";
    public static SYMBOL_TO_WILD_HALF_SPINE: string = "spine/SymbolToWild_half.json";
    public static X_WAYS_SPINE: string = "spine/X_Ways.json";
    public static FS_AND_SUPER_FS_INTRO_SPINE: string = "spine/FsSfs.json";
    public static X_SPLIT_SPINE: string = "spine/X_Split.json";
    public static SCATTER_SPINE: string = "spine/BN.json";
    public static X_BOMB_SPINE: string = "spine/X_Bomb.json";
    public static BW_V1_SPINE: string = "spine/big_win_v1.json";
    public static BW_V2_SPINE: string = "spine/big_win_v2.json";
    public static BW_V3_SPINE: string = "spine/big_win_v3.json";
    public static BW_V4_SPINE: string = "spine/big_win_v4.json";
    public static BW_V5_SPINE: string = "spine/big_win_v5.json";
    public static FS_OUTRO: string = "spine/FS_Outro.json";
    public static X_RIP_BUTTON: string = "spine/boostedxrip_button.json";
    public static X_RIP_BLAST: string = "spine/xrip_blast.json";
    public static MAX_WIN: string = "spine/Maxwincap.json";
    public static X_RIP_REEL_HIGHLIGHTER: string = "spine/Scatter_highlighter.json";
    public static BG_ANIM: string = "spine/bg_anim.json";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_SPLIT_SYMBOL_NUMBERS, "fonts/bitmapfonts/symXMultiplyer.fnt"),
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_WIN_NUMBERS, "fonts/bitmapfonts/WinNumbers.fnt"),
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS, "fonts/bitmapfonts/MultiplierNumbers.fnt"),
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_SFS_MULTIPLIER_NUMBERS, "fonts/bitmapfonts/Super_Bonus_Multiplier_Font.fnt"),
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_FS_OUTRO_NUMBER, "fonts/bitmapfonts/FSOutroNumber.fnt"),
                    new BitmapFontAsset(TheBorderGameAssets.BITMAP_FONT_FS_OUTRO_NUMBER_SHINE, "fonts/bitmapfonts/FSOutroNumberShine.fnt"),
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset(TheBorderGameAssets.SCATTER_SPINE, TheBorderGameAssets.SCATTER_SPINE),
                    new SpineAsset(TheBorderGameAssets.X_WAYS_SPINE, TheBorderGameAssets.X_WAYS_SPINE),
                    new SpineAsset(TheBorderGameAssets.X_BOMB_SPINE, TheBorderGameAssets.X_BOMB_SPINE),
                    new SpineAsset(TheBorderGameAssets.X_SPLIT_SPINE, TheBorderGameAssets.X_SPLIT_SPINE),
                    new SpineAsset(TheBorderGameAssets.X_NUDGE_SPINE, TheBorderGameAssets.X_NUDGE_SPINE),
                    new SpineAsset(TheBorderGameAssets.SYMBOL_TO_WILD_SPINE, TheBorderGameAssets.SYMBOL_TO_WILD_SPINE),
                    new SpineAsset(TheBorderGameAssets.SYMBOL_TO_WILD_HALF_SPINE, TheBorderGameAssets.SYMBOL_TO_WILD_HALF_SPINE),
                    new SpineAsset(TheBorderGameAssets.BW_V1_SPINE, TheBorderGameAssets.BW_V1_SPINE),
                    new SpineAsset(TheBorderGameAssets.BW_V2_SPINE, TheBorderGameAssets.BW_V2_SPINE),
                    new SpineAsset(TheBorderGameAssets.BW_V3_SPINE, TheBorderGameAssets.BW_V3_SPINE),
                    new SpineAsset(TheBorderGameAssets.BW_V4_SPINE, TheBorderGameAssets.BW_V4_SPINE),
                    new SpineAsset(TheBorderGameAssets.BW_V5_SPINE, TheBorderGameAssets.BW_V5_SPINE),
                    new SpineAsset(TheBorderGameAssets.FS_OUTRO, TheBorderGameAssets.FS_OUTRO),
                    new SpineAsset(TheBorderGameAssets.X_RIP_BUTTON, TheBorderGameAssets.X_RIP_BUTTON),
                    new SpineAsset(TheBorderGameAssets.X_RIP_BLAST, TheBorderGameAssets.X_RIP_BLAST),
                    new SpineAsset(TheBorderGameAssets.MAX_WIN, TheBorderGameAssets.MAX_WIN),
                    new SpineAsset(TheBorderGameAssets.X_RIP_REEL_HIGHLIGHTER, TheBorderGameAssets.X_RIP_REEL_HIGHLIGHTER),
                    new SpineAsset(TheBorderGameAssets.FS_AND_SUPER_FS_INTRO_SPINE, TheBorderGameAssets.FS_AND_SUPER_FS_INTRO_SPINE),
                    new SpineAsset(TheBorderGameAssets.BG_ANIM, TheBorderGameAssets.BG_ANIM)
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json")
                ]
            },
            {
                name: "fsSfs",
                assets: [
                    new TextureAsset("fsSfs0", "sheets/fsSfs/fsSfs0.json"),
                    new TextureAsset("fsSfs1", "sheets/fsSfs/fsSfs1.json")

                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {}
            },
            {
                name: "symbolsYellow",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsYellow0", "sheets/symbolsYellow/symbolsYellow0.json")
                ],
                animations: {}
            },
            {
                name: "symbolParts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolParts0", "sheets/symbolParts/symbolParts0.json")
                ],
                animations: {}
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}